// extracted by mini-css-extract-plugin
export default {"root":"InquiryWithoutPaymentForm_root__0Gz8k","submitButton":"InquiryWithoutPaymentForm_submitButton__aEEKK"};